// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const checkAuth = () => {
  const token = localStorage.getItem('auth_token');
  // Aquí puedes agregar tu lógica de validación del token
  return token === 'your_secure_token_here';
};

const PrivateRoute = ({ children }) => {
  const isAuthenticated = checkAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

export default PrivateRoute;